// extracted by mini-css-extract-plugin
export default {"bannerStart":"Banner_bannerStart__D90EM","header":"Banner_header__zEFOo","text":"Banner_text__OAgdv","image":"Banner_image__zEsUw"};